import { BaseError } from '@dynamic-labs-sdk/client';

export class NotStarknetProviderError extends BaseError {
  public readonly providerKey: string;

  constructor(params: { providerKey: string }) {
    super({
      cause: null,
      code: 'not_starknet_provider_error',
      docsUrl: null,
      name: 'NotStarknetProviderError',
      shortMessage: 'Provider is not a Starknet wallet provider',
    });

    this.providerKey = params.providerKey;
  }
}
